<template>
  <div>
    <a
      :href="href_full"
      target="_blank"
      class="btn btn-success whatsapp rounded-circle 0-2 position-fixed bottom-0 end-0 me-3 z-3"
      @mouseover="chamaTexto"
      @mouseout="ocultaTxt"
    >
      <i class="bi bi-whatsapp fs-2"></i>
    </a>
    <Transition>
      <div
        class="btn btn-success position-fixed bottom-0 end-0 me-3 whatsapp-txt z-3"
        v-show="fa_co"
      >
        Fale conosco
      </div>
    </Transition>
  </div>
</template>

<script>
export default {
  name: "Whatsapp",
  props: {
    txt: String,
    telefone: String,
  },
  data() {
    return {
      fa_co: false,
      href_full:
        `https://api.whatsapp.com/send?phone=` +
        this.telefone +
        `&text=` +
        this.txt,
    };
  },
  methods: {
    chamaTexto() {
      this.fa_co = true;
    },
    ocultaTxt() {
      this.fa_co = false;
    },
  },
  components: {},
};
</script>

<style scoped>
.whatsapp {
  margin-bottom: 80px;
}

.whatsapp-txt {
  margin-bottom: 140px;
  transition: 0.5s;
}
</style>